import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"

import { useSignUpModalState } from "@fuse/sharedComponents/globalQuickSignUpModal"
import LoadingSpinner from "@fuse/sharedComponents/loader/LoadingSpinner"
import OtpBox from "@fuse/sharedComponents/OTPComponent/OTPComponent"
import { showErrorToast } from "@fuse/sharedComponents/themeToast/toastUtils"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { TWebUser } from "@letshang/constants"
import {
  ConfirmationResult,
  PhoneAuthProvider,
  signInWithCredential,
} from "firebase/auth"
import { get, isEmpty } from "lodash-es"
import { useRecoilState } from "recoil"

import { userState } from "@fuse/recoil/signup"

import { auth } from "@firebaseConfig/clientApp"

import { getUserInfo } from "@api/firebaseWrappedApis"

interface VerifyOtpProps {
  closeModal?: () => void
  setStep: React.Dispatch<React.SetStateAction<number>>
  signInTheUser: (number: string) => Promise<ConfirmationResult>
}

type ErrState = {
  state: null | "success" | "error"
  errMsg: string
}

const VerifyOtpComponent: React.FC<VerifyOtpProps> = ({
  closeModal = () => {},
  setStep,
  signInTheUser,
}) => {
  const [otp, setOtp] = useState<string>("")
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [verificationState, setVerificationState] = useState<ErrState>({
    state: null,
    errMsg: "",
  })
  const { setFastSignUpStage } = useSignUpModalState()

  const VerifyOtp = async () => {
    try {
      setIsLoading(true)
      const verificationId = user?.verificationId

      const credential = PhoneAuthProvider.credential(verificationId, otp)
      const signIn = await signInWithCredential(auth, credential)

      const userInfo = (await getUserInfo({})) as any
      const currentUserInfo = get(userInfo, "userInfo")
      if (currentUserInfo?.displayName) {
        setUser((prev: TWebUser) => ({
          ...prev,
          ...currentUserInfo,
          uid: signIn.user.uid,
          name: currentUserInfo.displayName,
          firstName: currentUserInfo.displayName.split(" ")[0],
          lastName: currentUserInfo.displayName.split(" ")[1],
          isOnboarded: true,
          isLoggedIn: true,
        }))

        setFastSignUpStage("done")
        closeModal()

        // setStep(1);
        // if (!user?.isTicketedEvent) {
        //   if (user?.eventId || eventId) {
        //     await joinEvent(user?.eventId ?? eventId).then(
        //       (res: TEventDetail) => {
        //         if (res?.success) {
        //           toast.success(
        //             res?.data?.eventName
        //               ? `You successfully joined "${res?.data?.eventName}"`
        //               : res?.message
        //           );
        //           // navigate(user.redirectUrl || "/")
        //         } else toast.error(res?.message);
        //         closeModal();
        //       }
        //     );
        //   }
        // } else {
        //   closeModal();
        //   navigate(
        //     ROUTES.CHOOSE_TICKET.replace(":eventId", eventId ?? user?.eventId)
        //   );
        // }
      } else {
        setUser((prev: TWebUser) => ({
          ...prev,
          verified: true,
          uid: signIn.user.uid,
        }))
        setStep(3)
      }
    } catch (error: any) {
      console.error(error)
      const errMsg = error.message
      if (errMsg.includes("auth/invalid-verification-code")) {
        showErrorToast("Invalid OTP")
        setVerificationState({ state: "error", errMsg: "Invalid OTP" })
      } else if (errMsg.includes("auth/code-expired")) {
        showErrorToast("Code expired, please try again")
        setVerificationState({
          state: "error",
          errMsg: "Code expired, please try again",
        })
      }
    } finally {
      setOtp("")
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (otp.toString().length === 6) {
      VerifyOtp()
    }
    if (otp.length > 0) {
      setVerificationState({
        state: null,
        errMsg: "",
      })
    }
  }, [otp])

  // culprit
  // useEffect(() => {
  //   if (user && !user.phone) {
  //     setStep(1)
  //   }
  // }, [user])

  async function resendOtp() {
    try {
      const confirmation = await signInTheUser(user.phone)
      setUser((prev: TWebUser) => ({
        ...prev,
        verificationId: confirmation.verificationId,
      }))
    } catch (error: any) {
      console.error(error)
      switch (error?.code) {
        case "auth/too-many-requests":
          showErrorToast("Too many requests. Please try again later.")
          break
        case "auth/invalid-phone-number":
          showErrorToast("The phone number is invalid.")
          break
        default:
          showErrorToast("Something went wrong. Please try again later.")
          break
      }
    }
  }

  const isValidOTP = isEmpty(verificationState?.errMsg)

  return (
    <div className=" mt-6">
      <div className="relative z-[10]">{isLoading && <LoadingSpinner />}</div>
      <div className=" mb-1">
        <p className="text-sm text-white/35 font-medium text-left">
          We’ve sent an SMS Code
        </p>
      </div>

      <OtpBox
        state={otp}
        length={6}
        setState={setOtp}
        verificationState={verificationState?.state}
        errorMsg={verificationState?.errMsg}
      />
      <div className="mx-auto mt-2">
        <FancyText className="text-sm font-medium text-left">
          <span
            className={` text-sm ${isValidOTP ? "text-white/35" : "text-red-400"}`}
          >
            {isValidOTP
              ? "Didn’t get the code?"
              : "Your entered code is incorrect."}{" "}
          </span>
          <a
            href="javascript:void(0)"
            onClick={() => {
              resendOtp()
            }}
            className="text-white underline"
          >
            Resend
          </a>
        </FancyText>
      </div>
    </div>
  )
}

export default VerifyOtpComponent
